// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"_3HwyP","effectsGrayscale30":"_32UMa","resetList":"_2KHBa","wrapper":"_3oSGB","dot":"qYqUz","wave":"_3dzRj"};